import { Injectable, Inject } from "@angular/core";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { MAT_DATE_LOCALE } from "@angular/material/core";

@Injectable()
export class CustomMomentDateAdapter extends MomentDateAdapter {
  constructor(@Inject(MAT_DATE_LOCALE) dateLocale: string) {
    super(dateLocale);
  }

  getMonthNames(style: "long" | "short" | "narrow"): string[] {
    if (style === "short") {
      return ["Ene.", "Feb.", "Mar.", "Abr.", "May.", "Jun.", "Jul.", "Ago.", "Sep.", "Oct.", "Nov.", "Dic."];
    }
    return super.getMonthNames(style);
  }

  getDayOfWeekNames(style: "long" | "short" | "narrow"): string[] {
    if (style === "narrow") {
      return ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"];
    }
    return super.getDayOfWeekNames(style);
  }
}
